// アップロードのプログレスバーを送信ボタンの上へ移動
export default function initMoveProgressBar() {
    const $ = jQuery;
    $('.quform').each(function () {
        const $progress = $(this).find('.quform-upload-progress-wrap');
        const $submitButton = $(this).find('.quform-element-submit');

        if ($progress.length && $submitButton.length) {
            $progress.insertBefore($submitButton);
        }
    });
}